export const channelSavedFailed = {
  title: '无法操作，请联系线上顾问',
};
